module.exports = __webpack_public_path__ + "img/closing-stat.41281fad.svg";